import { type FC } from "react";
import { Stack } from "@mui/material";
import { ClipboardTypography } from "@packsize/components";
import { useToast } from "@packsize/toast";

interface InfoRowProps {
	readonly label: string;
	readonly value: string | number;
}

export const InfoRow: FC<InfoRowProps> = ({ label, value }) => {
	const { toastSuccess, toastError } = useToast();

	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
			<ClipboardTypography
				color="text.secondary"
				fontWeight={500}
				onSuccess={() => toastSuccess({ message: "Copied to clipboard" })}
				onError={() => toastError({ message: "Failed to copy to clipboard" })}
			>
				{label}
			</ClipboardTypography>
			<ClipboardTypography
				variant="body1"
				onSuccess={() => toastSuccess({ message: "Copied to clipboard" })}
				onError={() => toastError({ message: "Failed to copy to clipboard" })}
			>
				{value}
			</ClipboardTypography>
		</Stack>
	);
};
